{
  "title": "Products",
  "subtitle": "Everything you keep in stock. Open a product to see where it is and how it moved.",
  "importFromExcel": "Import from Excel",
  "exportToExcel": "Export to Excel",
  "newProduct": "New product",
  "status": {
    "active": "Active",
    "archived": "Archived"
  },
  "states": {
    "in_stock": "In stock",
    "low": "Low",
    "out": "Out",
    "negative": "Negative",
    "overstock": "Overstock"
  },
  "tabs": {
    "all": "All",
    "low": "Low",
    "out": "Out",
    "negative": "Negative",
    "overstock": "Overstock",
    "archived": "Archived"
  },
  "empty": {
    "title": "No product yet",
    "text": "Add your products one by one, or import your whole catalog from an Excel or CSV file."
  },
  "noMatch": {
    "title": "No product matches",
    "text": "Try another word, or clear the filters."
  },
  "filters": {
    "search": "Name, SKU or barcode",
    "category": "Category",
    "allCategories": "All categories",
    "brand": "Brand",
    "allBrands": "All brands",
    "sort": "Sort",
    "clear": "Clear",
    "attribute": "Attribute",
    "allAttributes": "Any attribute",
    "attributeValue": "Value of {{name}}",
    "anyValue": "Any value",
    "contains": "Contains…",
    "min": "From",
    "max": "To",
    "attributeMin": "{{name}} from",
    "attributeMax": "{{name}} to"
  },
  "sort": {
    "name_asc": "Name A to Z",
    "name_desc": "Name Z to A",
    "sku_asc": "SKU A to Z",
    "sku_desc": "SKU Z to A",
    "stock_asc": "Lowest stock first",
    "stock_desc": "Highest stock first",
    "createdAt_asc": "Oldest first",
    "createdAt_desc": "Newest first"
  },
  "columns": {
    "product": "Product",
    "codes": "SKU · Barcode",
    "totalStock": "Total stock",
    "minMax": "Min / Max",
    "averageCost": "Avg cost",
    "sellingPrice": "Selling price",
    "stockValue": "Stock value",
    "state": "State",
    "location": "Location",
    "min": "Min",
    "max": "Max",
    "quantity": "Quantity",
    "value": "Value (TND)"
  },
  "showing_one": "Showing {{first}}–{{last}} of {{total}} product",
  "showing_other": "Showing {{first}}–{{last}} of {{total}} products",
  "pricesIn": "prices in TND",
  "fields": {
    "name": "Product name",
    "description": "Description",
    "category": "Category",
    "categories": "Categories",
    "brand": "Brand",
    "unit": "Unit",
    "sku": "SKU",
    "skuLong": "SKU (your product code)",
    "barcode": "Barcode",
    "costPrice": "Reference cost price",
    "sellingPrice": "Selling price",
    "taxRate": "VAT rate",
    "listPrice": "{{list}} price"
  },
  "photo": {
    "title": "Photo",
    "alt": "Product photo",
    "drop": "Drop a photo or click to choose",
    "limits": "JPG, PNG or WebP, up to 5 MB",
    "change": "Change",
    "remove": "Remove",
    "wrongType": "Use a JPG, PNG or WebP picture",
    "tooLarge": "The photo must be 5 MB or less"
  },
  "form": {
    "newTitle": "New product",
    "editTitle": "Edit",
    "subtitle": "Fields marked * are required. You can change everything later, except the SKU once the product has moved.",
    "sections": {
      "what": "1 · What is it?",
      "codes": "2 · Codes",
      "prices": "3 · Prices",
      "warn": "4 · When should we warn you?",
      "attributes": "5 · Attributes",
      "customizations": "6 · Customizations"
    },
    "choose": "Choose…",
    "noBrand": "No brand",
    "deactivated": "deactivated",
    "noCategories": "There is no category yet: create the category tree first.",
    "addCategory": "Add a category…",
    "categoriesHint": "The product is found in each of them. The first is the main one: reports and the store’s breadcrumb use it.",
    "categoriesFull": "That is the most: {{max}} categories.",
    "mainCategory": "Main",
    "makeMain": "Make main",
    "removeCategory": "Remove {{name}}",
    "openConfiguration": "Open Configuration",
    "wholeNumbers": "whole numbers",
    "decimals_one": "{{count}} decimal",
    "decimals_other": "{{count}} decimals",
    "skuAuto": "Create it for me:",
    "skuManual": "I will type my own code",
    "skuHint": "Capital letters, digits, dots, dashes and slashes.",
    "skuLocked": "The SKU cannot change any more: this product has moved.",
    "skuAutoTaken": "This automatic SKU was just used: save again to get the next one.",
    "barcodeFree": "Free to use: no other product has this barcode",
    "barcodeTaken": "This barcode already belongs to {{name}} ({{sku}}).",
    "generateBarcode": "No barcode? Generate an internal one",
    "costHint": "Only suggested when you receive stock. The real cost is the average the system calculates.",
    "priceHint": "3 decimals, as on Tunisian invoices.",
    "taxRateHint": "Prices are tax included; receipts show the VAT of this rate.",
    "noTaxRates": "No VAT rate yet: add your rates in Configuration, Sales.",
    "defaultTaxRate": "Company default ({{name}} · {{rate}})",
    "noTaxRate": "No VAT rate (0%)",
    "listPriceHint": "Empty: sells at the selling price.",
    "warnHint": "At each location: at or below its minimum you get a “Low stock” alert, above its maximum an “Overstock” alert. A site’s limits count its sub-locations too. Leave a location empty for none.",
    "afterSaving": "After saving",
    "afterSavingText": "The product starts with 0 in every location. Add the quantities you already have with an opening stock, or receive new goods with a stock in (phase 3).",
    "saveAndAdd": "Save and add another",
    "saveProduct": "Save product",
    "saved": "Product saved",
    "created": "{{name}} created as {{sku}}",
    "sectionsVariants": {
      "what": "1 · What is it?",
      "options": "2 · Options",
      "codes": "3 · Code",
      "prices": "4 · Prices",
      "variants": "7 · Variants",
      "attributes": "5 · Attributes",
      "customizations": "6 · Customizations"
    },
    "wholesaleHint": "Empty: no wholesale price, so it is not sold in wholesale mode."
  },
  "detail": {
    "more": "More actions",
    "brand": "Brand: {{name}}",
    "unit": "Unit: {{name}} ({{symbol}})",
    "negativeIn_one": "Negative in {{count}} location",
    "negativeIn_other": "Negative in {{count}} locations",
    "negativeShows": "{{location}} shows {{quantity}} {{unit}}.",
    "negativeExplain": "More was issued than the system had. Count the shelf, or record the receipt that was missed.",
    "totalStock": "Total stock",
    "averageCost": "Average cost",
    "averageCostHint": "Weighted average, set by the system",
    "stockValue": "Stock value",
    "noCostYet": "No receipt yet",
    "sellingPrice": "Selling price",
    "margin": "Margin about {{percent}}% on average cost",
    "pricesTitle": "Prices",
    "pricesHint": "Tax included, per price list",
    "fromSellingPrice": "Selling price",
    "fromProduct": "From the product",
    "ownPrice": "Own price",
    "noPrice": "No price",
    "whereItIs": "Where it is",
    "perLocationHint": "Min and max can be set per location",
    "noLocations": "No location yet: create your sites in Locations.",
    "systemLocation": "System location",
    "empty": "Empty",
    "total": "Total",
    "changes": "Changes to this product",
    "changesHint": "Every change is recorded and can never be altered.",
    "details": "Product details",
    "unitDecimals_one": "{{name}} ({{count}} decimal)",
    "unitDecimals_other": "{{name}} ({{count}} decimals)",
    "created": "Created",
    "lastChange": "Last change",
    "dateBy": "{{date}} by {{name}}",
    "archive": "Archive product",
    "archiveHint": "Archiving is possible only when the stock is zero in every location.",
    "canDeleteHint": "This product was never used, so it can also be deleted.",
    "cannotDeleteHint": "This product has history, so it cannot be deleted.",
    "archiveTitle": "Archive {{name}}?",
    "archiveText": "It leaves the lists and can no longer be received or issued. Its history stays, and you can restore it at any time.",
    "archived": "Product archived",
    "restore": "Restore product",
    "restoreHint": "Restoring brings the product back into the lists and operations.",
    "restored": "Product restored",
    "delete": "Delete product",
    "deleteTitle": "Delete {{name}}?",
    "deleteText": "This product was never used. It is removed for good; the activity log keeps a record of the deletion.",
    "deleted": "{{name}} deleted",
    "receive": "Receive",
    "issue": "Issue",
    "correctStock": "Correct stock",
    "seeStockLevels": "See it in the stock levels",
    "movements": "Movement history",
    "allLocations": "All locations",
    "export": "Export",
    "noMovement": "No movement yet: receive stock or record the opening stock.",
    "when": "When",
    "document": "Document",
    "change": "Change",
    "balanceAfter": "Balance after",
    "by": "By",
    "reversal": "reversal",
    "atCost": "at {{cost}} TND",
    "negativeConfirmed": "Negative confirmed",
    "fullHistory": "See the full history in the activity log",
    "loadMore": "Show more",
    "pastDate": "Stock on a past date",
    "pastDateHint": "Every movement is kept, so you can see the quantity on any day.",
    "date": "Date",
    "totalThen": "Total then",
    "reservedAt": "{{site}}: {{reserved}} {{unit}} reserved for orders, {{available}} available",
    "noWholesale": "Not set: not sold at wholesale"
  },
  "kind": {
    "label": "Type of product",
    "simple": "Simple product",
    "simpleHint": "One item: one SKU, one barcode, one stock.",
    "parent": "Product with variants",
    "parentHint": "Comes in several colours, sizes or finishes. Each variant has its own SKU, barcode and stock."
  },
  "variants": {
    "optionsHint": "What the variants differ by, up to 3 options. Each combination of values is a variant.",
    "noOptions": "No option yet. Add the first one: Color, Size, Material…",
    "addOption": "Add an option",
    "customOption": "New option, typed by hand",
    "valueCount_one": "{{count}} value",
    "valueCount_other": "{{count}} values",
    "maxOptions": "3 options at most.",
    "optionName": "Option",
    "optionNamePlaceholder": "Color, Size, Material…",
    "presentation": "Shown as",
    "optionUsed": "Its values are used by variants",
    "removeOption": "Remove the option {{name}}",
    "pick": "Pick from the library",
    "values": "Values",
    "codeHint": "(the code goes into variant SKUs)",
    "noValues": "No value yet: pick some above or type them below.",
    "label": "Value",
    "code": "Code",
    "color": "Colour of {{name}}",
    "removeValue": "Remove {{name}}",
    "valueUsed_one": "Used by {{count}} variant",
    "valueUsed_other": "Used by {{count}} variants",
    "addValues": "Add values",
    "addValuesPlaceholder": "Type a value and press Enter. Commas add several.",
    "add": "Add",
    "existingTake": "The variants that exist are",
    "existingHint": "They take this value of the new option.",
    "skuHint": "Each variant gets this SKU and its value codes (PNT-10L-WHT), unless you type its own.",
    "pricesHint": "Variants without a price of their own use these.",
    "listPriceHint": "Empty: variants sell at their selling price, unless they have their own.",
    "tableHint": "One line per combination. Untick the ones you do not sell. Empty SKUs and prices follow the product.",
    "noRows": "Add an option and its values: the combinations show here.",
    "count_one": "{{count}} variant",
    "count_other": "{{count}} variants",
    "newCount_one": "{{count}} new",
    "newCount_other": "{{count}} new",
    "tooMany": "{{count}} combinations: {{max}} variants at most. Use fewer values.",
    "needOption": "Add at least one option with its values.",
    "none": "Tick at least one combination.",
    "stranded": "Some variants no longer match a combination: put back the options and values they use.",
    "fixErrors": "Some options or variants need a correction.",
    "saved_one": "{{name}} saved with {{count}} variant",
    "saved_other": "{{name}} saved with {{count}} variants",
    "selectAll": "Create every new combination",
    "createRow": "Create {{label}}",
    "keepRow": "{{label}} in use",
    "hasStock": "It has stock: it stays in use",
    "new": "New",
    "archived": "Archived",
    "inStock": "{{quantity}} {{unit}} in stock",
    "columns": {
      "active": "In use",
      "variant": "Variant",
      "sku": "SKU",
      "barcode": "Barcode",
      "costPrice": "Cost price",
      "sellingPrice": "Selling price"
    },
    "bulk": {
      "scope": "Fill for",
      "all": "All variants",
      "field": "Field",
      "value": "Value",
      "empty": "Empty",
      "apply": "Fill",
      "hint": "An empty value clears the field: the variants follow the product again."
    },
    "convert": {
      "teaser": "Comes in several colours or sizes?",
      "teaserText": "Turn it into a product with variants. This item becomes its first variant and keeps its stock and history.",
      "action": "Add variants",
      "title": "Add variants to {{name}}",
      "description": "Choose the options. This item becomes the first variant; you add the others next. Changes not saved on this page are not kept.",
      "thisIs": "This item ({{sku}}) is",
      "parentSku": "SKU of the product with variants",
      "parentSkuHint": "Leave empty for the next automatic SKU. The item keeps {{sku}}.",
      "submit": "Add variants",
      "done": "{{name}} now has variants: tick the other combinations and save."
    },
    "page": {
      "variantOf": "Variant of",
      "edit": "Edit variants",
      "title": "Variants",
      "hint": "Each variant has its own SKU, barcode and stock. Click a photo to change it.",
      "none": "No variant yet: edit the product to tick its combinations.",
      "ownPrice": "own price",
      "archivedCount_one": "{{count}} archived variant",
      "archivedCount_other": "{{count}} archived variants",
      "changePhoto": "Change the photo of {{label}}",
      "photoSaved": "Photo of {{label}} saved",
      "statVariants": "Variants",
      "inStockCount_one": "{{count}} in stock",
      "inStockCount_other": "{{count}} in stock",
      "valueNote": "Each variant at its own average cost",
      "pickerTitle": "Variant",
      "pickerHint": "Pick another value to open that variant.",
      "unavailable": "{{label}} (none)",
      "archiveHint": "The product is archived with its variants, only when none has stock left.",
      "archiveText": "The product and its active variants leave the lists and can no longer be received or issued. Their history stays; restoring the product brings them back.",
      "deleteText": "The product and its variants were never used. They are removed for good; the activity log keeps a record of the deletion."
    },
    "grid": {
      "title": "{{name}}: quantity per variant",
      "hint": "Type a quantity for each variant to add; leave the others empty.",
      "hintAt": "Type a quantity for each variant to add; leave the others empty. Stock shown at {{location}}.",
      "quantity": "Quantity",
      "quantityOf": "Quantity of {{label}}",
      "stock": "{{quantity}} in stock",
      "setAll": "Same quantity for all",
      "apply": "Fill",
      "summary_one": "{{count}} variant, {{total}} {{unit}} in all",
      "summary_other": "{{count}} variants, {{total}} {{unit}} in all",
      "add_one": "Add {{count}} line",
      "add_other": "Add {{count}} lines",
      "addNone": "Add",
      "empty": "This product has no active variant: edit it to add some.",
      "pick_one": "{{count}} variant · type the quantities",
      "pick_other": "{{count}} variants · type the quantities"
    },
    "wholesaleHint": "Empty: variants have no wholesale price unless they have their own.",
    "limits": {
      "at": "Limits at",
      "hint": "Each variant’s minimum and maximum at this location: at or below the minimum, a “Low stock” alert; above the maximum, an “Overstock” alert. A site’s count its sub-locations too. Choose another location to set its own: what you typed stays.",
      "option": "{{name}} ({{count}})",
      "toCheck": "{{name}} · to check",
      "elsewhere": "Limits to check at: {{places}}",
      "minAt": "Min at {{place}}",
      "maxAt": "Max at {{place}}",
      "bulkHint": "An empty value removes the limit."
    },
    "view": {
      "label": "What the table shows",
      "prices": "Codes and prices",
      "limits": "Stock limits",
      "pricesToCheck": "Codes or prices to check: see Codes and prices."
    }
  },
  "extras": {
    "fixErrors": "Some attributes or customizations need a correction.",
    "attributes": {
      "hint": "What describes the product, from the attribute library: weight, material, waterproof. They help find and compare products; they create no variants.",
      "none": "No attribute yet.",
      "add": "Add an attribute",
      "emptyLibrary": "The attribute library is empty.",
      "yes": "Yes",
      "no": "No",
      "remove": "Remove {{name}}"
    },
    "customizations": {
      "hint": "Asked when the item goes out: engraving text, tint, length cut. They are recorded on the issue line and have no stock of their own.",
      "none": "No customization.",
      "add": "Add a customization",
      "name": "Customization",
      "namePlaceholder": "Tint, Engraving, Length…",
      "type": "Answered with",
      "types": {
        "choice": "A list of choices",
        "text": "Free text",
        "number": "A number"
      },
      "choices": "Choices",
      "choicesPlaceholder": "Type a choice and press Enter. Commas add several.",
      "removeChoice": "Remove {{name}}",
      "unit": "Unit",
      "required": "Required on every issue",
      "remove": "Remove the customization {{name}}",
      "title": "Customizations",
      "pageHint": "Asked on each issue of this product.",
      "requiredBadge": "Required"
    }
  },
  "online": {
    "title": "Online store",
    "hint": "Whether the product is sold online, how it is titled there, and its photos.",
    "published": "Online",
    "notPublished": "Not online",
    "sold": "Sold online",
    "soldHint": "Shown in the online store, at the online price list.",
    "archived": "An archived product is not sold online.",
    "titleField": "Online title",
    "titleHint": "Empty: the product name.",
    "slug": "Address",
    "slugHint": "The end of the product page address. Changed, the old address leads to the new one.",
    "slugAuto": "Empty: made from the title ({{slug}}).",
    "description": "Online description",
    "descriptionHint": "Empty: the product description.",
    "sortOrder": "Order in the store",
    "sortOrderHint": "Smaller numbers come first in the lists.",
    "save": "Save the online store",
    "saved": "Online store saved",
    "savedPublished": "The product is in the online store",
    "gallery": "Photos {{count}}/{{max}}",
    "galleryHint": "Shown after the main photo, in this order (JPEG, PNG or WebP).",
    "noPhotos": "No photo besides the main one.",
    "addPhoto": "Add a photo",
    "removePhoto": "Remove the photo",
    "moveLeft": "Move earlier",
    "moveRight": "Move later",
    "variant": "A variant is sold online with its product:",
    "seo": {
      "title": "Search and sharing",
      "hint": "What Google and a share on Facebook, Instagram or WhatsApp show of the product.",
      "seoTitle": "Title for search and sharing",
      "seoTitleHint": "Empty: the online title.",
      "seoDescription": "Description for search and sharing",
      "seoDescriptionHint": "Empty: the online description.",
      "socialImage": "Sharing image",
      "socialImageHint": "Empty: the first photo. Saved as soon as it is chosen.",
      "imageSaved": "Sharing image saved."
    }
  },
  "selling": {
    "title": "Selling",
    "saved": "Saved",
    "onSale": "On sale",
    "offSale": "Off sale",
    "onSaleHint": "Sold at the tills, online (when published) and in orders.",
    "onSaleVariant": "This variant is sold wherever its product is.",
    "offSaleHint": "Not sold anywhere for now. Its stock stays, can be counted and moved; switch it back on at any time.",
    "parentOff": "{{name}} is off sale: none of its variants is sold.",
    "shownOnline": "Shown online",
    "shownOnlineHint": "Offered in the online store with its product.",
    "hiddenOnlineHint": "Sold in the shops only: the online store does not show it.",
    "notPublished": "Its product is not in the online store yet.",
    "online": "Online",
    "hidden": "Hidden",
    "onSaleFor": "{{label}} on sale",
    "onlineFor": "{{label}} shown online",
    "select": "Tick {{label}}",
    "selectAll": "Tick every variant",
    "selected_one": "{{count}} variant ticked",
    "selected_other": "{{count}} variants ticked",
    "putOnSale": "Put on sale",
    "takeOffSale": "Take off sale",
    "showOnline": "Show online",
    "hideOnline": "Hide online",
    "clear": "Untick"
  },
  "variantPhotos": {
    "title": "Photos of this variant",
    "hint": "Shown in the online store when a customer picks this variant, after its photo.",
    "galleryHint": "A variant without photos of its own shows its product's.",
    "column": "Photos",
    "open": "Photos of {{label}}",
    "dialogTitle": "Photos of {{label}}",
    "copy": "Use them for other variants",
    "copyTitle": "Use the photos of {{label}}",
    "copyHint_one": "{{count}} photo, copied to the variants you tick.",
    "copyHint_other": "{{count}} photos, copied to the variants you tick.",
    "copyConfirm_one": "Copy to {{count}} variant",
    "copyConfirm_other": "Copy to {{count}} variants",
    "copied_one": "Photos copied to {{count}} variant",
    "copied_other": "Photos copied to {{count}} variants",
    "has_one": "{{count}} photo now",
    "has_other": "{{count}} photos now",
    "all": "Tick all",
    "none": "Untick all",
    "replaces": "Their gallery is replaced by these photos, and their photo too when this variant has one. Each variant keeps its own copies."
  },
  "list": {
    "wholesale": "Wholesale {{price}}"
  },
  "labels": {
    "button": "Print labels",
    "title": "Barcode labels",
    "subtitle": "The format comes from Configuration › Labels; change it for this print if needed.",
    "print": "Print",
    "count_one": "{{count}} label",
    "count_other": "{{count}} labels",
    "format": "Label format",
    "size": "Labels of {{width}} × {{height}} mm",
    "rolls": "Label roll (thermal label printer)",
    "rollSize": "{{width}} × {{height}} mm",
    "customRoll": "Roll, other size",
    "sheets": "A4 sheet (office printer)",
    "sheetGrid_one": "A4, {{columns}} × {{rows}} ({{count}} label)",
    "sheetGrid_other": "A4, {{columns}} × {{rows}} ({{count}} labels)",
    "customSheet": "A4, other grid",
    "width": "Width",
    "height": "Height",
    "columns": "Columns",
    "rows": "Rows",
    "margin": "Sheet margin",
    "marginHint": "Around the grid, on every side.",
    "gap": "Gap between labels",
    "shows": "On the label",
    "switches": {
      "showOptions": "The options after the name (S / Black)",
      "showPrice": "The price",
      "showSku": "The SKU",
      "showCompany": "The shop's name"
    },
    "priceList": "Price shown",
    "startAt": "Start at label",
    "startAtHint": "On a sheet already used, the first labels stay blank.",
    "invalid": "Check the format: labels of 15 to 150 mm, up to 8 columns and 30 rows.",
    "narrow": "Some barcodes are very narrow on this label: choose a wider label, or check that they scan.",
    "unreadable": "No barcode can carry {{codes}}: it prints as text. Give these products a barcode or an SKU without accents.",
    "noPrice": "Some products have no price on {{list}}: their labels show none.",
    "noPriceShort": "no price",
    "tooMany": "At most {{max}} labels a print.",
    "copiesOf": "Labels of {{name}}"
  }
}
